export const currencyList = [
	{ countryCode: 'DEU', code: 'EUR', locale: 'de-DE', symbol: '€' },
	{ countryCode: 'CHE', code: 'CHF', locale: 'de-CH', symbol: 'CHF' },
	{ countryCode: 'AUT', code: 'EUR', locale: 'de-AT', symbol: '€' },
	{ countryCode: 'USA', code: 'USD', locale: 'en-US', symbol: '$' },
	{ countryCode: 'TUR', code: 'TRY', locale: 'tr-TR', symbol: 'TL' },
]
